import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { ReactComponent as Cancel } from "./Assets/svgs/Cancel.svg";

function Contact() {
  const [darkMode, setDarkMode] = useState(false);
  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    subject: Yup.string().required("Subject is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    message: Yup.string().required("Message is required"),
  });
  const [save, setSave] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      subject: "",
      email: "",
      message: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      // console.log(values);
      setLoading(true);
      const formData = {
        fullName: values.fullName,
        subject: values.subject,
        email: values.email,
        message: values.message,
      };
      try {
        await fetch("https://candy-mailer.onrender.com/v1/contact-us", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }).then((res) => {
          setLoading(false);
          if (res.status === 200) {
            console.log("success");
            setSave(true);
          } else {
            console.log("error");
          }
        });
      } catch (error) {
        console.log("An Error Occurred: ", error);
      }
    },
  });

  useEffect(() => {
    const savedMode = localStorage.getItem("theme");
    const systemPreference = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (savedMode === "dark" || (!savedMode && systemPreference)) {
      document.documentElement.classList.add("dark");
      setDarkMode(true);
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  };
  return (
    <>
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className=" w-full flex justify-center items-center h-fit pt-[128px] pb-[48px] 100:px-6 md:px-[64px]">
        <div className="100:w-full 2xl:w-[1312px] flex-col justify-start items-center gap-12 inline-flex">
          <div className="w-full flex-col justify-center items-center gap-4 inline-flex">
            <div className=" w-full footer  p-2.5 flex-col justify-center items-center gap-3 flex">
              <h1 className={`self-stretch ${darkMode ? "text-[#F5F6F6]" : "text-[#393c40]"} 100:text-3xl text-center md:text-5xl font-semibold font-inter`}>Get in Touch</h1>
              <div className={`100:w-full  text-center ${darkMode ? "text-[#babdbf]" : "text-[#637077]"} text-lg font-normal font-inter leading-[25px]`}>Let's create something amazing together! Drop me a line and let's get started. </div>
            </div>
            <div className={`h-px w-full ${darkMode ? "bg-[#7e8b92]" : "bg-[#ccd2d5]"}`} />
          </div>
          <form onSubmit={formik.handleSubmit} className="w-full contact flex-col justify-start items-start gap-6 inline-flex">
            <label className={`flex-col w-full justify-start items-start gap-1.5 inline-flex ${darkMode ? "text-[#e4e7e9]" : "text-[#495055]"} text-sm font-medium font-inter leading-tight`} htmlFor="Full name">
              Full Name
              <input
                className={`h-12 w-full px-4 py-3 ${
                  darkMode ? "border-[#a9b2b7] text-[#a9b2b7] bg-[#1A1B1C] outline-[#2F45FF]" : "outline-[#0c0eff] bg-[#f0f0f6]/80 text-[#637077] border-[#ccd2d5]"
                } rounded-lg shadow border font-inter text-base font-normal `}
                placeholder="Enter your full name"
                type="text"
                id="fullName"
                {...formik.getFieldProps("fullName")}
              />
              {formik.touched.fullName && formik.errors.fullName ? <div className=" text-red-400 text-base">{formik.errors.fullName}</div> : null}
            </label>
            <div className="w-full 100:flex-col lg:flex-row justify-start items-start gap-6 inline-flex">
              <div className="lg:w-[450px] 100:w-full flex-col justify-start items-start gap-6 inline-flex">
                <label className={`flex-col w-full justify-start items-start gap-1.5 inline-flex ${darkMode ? "text-[#e4e7e9]" : "text-[#495055]"} text-sm font-medium font-inter leading-tight`} htmlFor="Email">
                  Email Address
                  <input
                    className={`h-12 w-full px-4 py-3 ${
                      darkMode ? "border-[#a9b2b7] text-[#a9b2b7] bg-[#1A1B1C] outline-[#2F45FF]" : "outline-[#0c0eff] bg-[#f0f0f6]/80 text-[#637077] border-[#ccd2d5]"
                    } rounded-lg shadow border font-inter text-base font-normal `}
                    placeholder="Enter your email address"
                    type="email"
                    id="email"
                    {...formik.getFieldProps("email")}
                  />
                  {formik.touched.email && formik.errors.email ? <div className=" text-red-400 text-base">{formik.errors.email}</div> : null}
                </label>
                <label className={`flex-col w-full justify-start items-start gap-1.5 inline-flex ${darkMode ? "text-[#e4e7e9]" : "text-[#495055]"} text-sm font-medium font-inter leading-tight`} htmlFor="Subject">
                  Subject
                  <input
                    className={`h-12 w-full px-4 py-3 ${
                      darkMode ? "border-[#a9b2b7] text-[#a9b2b7] bg-[#1A1B1C] outline-[#2F45FF]" : "outline-[#0c0eff] bg-[#f0f0f6]/80 text-[#637077] border-[#ccd2d5]"
                    } rounded-lg shadow border font-inter text-base font-normal `}
                    placeholder="Enter your message subject"
                    type="text"
                    id="subject"
                    {...formik.getFieldProps("subject")}
                  />
                  {formik.touched.subject && formik.errors.subject ? <div className=" text-red-400 text-base">{formik.errors.subject}</div> : null}
                </label>
              </div>
              <label className={`flex-col w-full justify-start items-start gap-1.5 inline-flex ${darkMode ? "text-[#e4e7e9]" : "text-[#495055]"} text-sm font-medium font-inter leading-tight`} htmlFor="Subject">
                Message
                <textarea
                  className={`h-[148px] w-full px-4 py-3 ${
                    darkMode ? "border-[#a9b2b7] text-[#a9b2b7] bg-[#1A1B1C] outline-[#2F45FF]" : "outline-[#0c0eff] bg-[#f0f0f6]/80 text-[#637077] border-[#ccd2d5]"
                  } rounded-lg shadow border font-inter text-base font-normal `}
                  placeholder="Enter your message...."
                  id="message"
                  {...formik.getFieldProps("message")}
                />
                {formik.touched.message && formik.errors.message ? <div className=" text-red-400 text-base">{formik.errors.message}</div> : null}
              </label>
            </div>
            <div className=" w-full flex justify-end items-end">
              <button
                type="submit"
                className={`h-[43px] 100:w-full phone:w-[300px] px-[25px] hover:bg-[#fd992f] text-[#25282b] text-2xl font-medium font-inter py-[5px] bg-[#ffb600] rounded-3xl ${
                  darkMode ? "shadow-customWhite" : " shadow-customBlack"
                } justify-center items-center gap-2.5 inline-flex`}
              >
                {isLoading ? "Loading...." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer darkMode={darkMode} />
      {save && (
        <>
          <div className={` transition-opacity  items-center flex-col  flex justify-between fixed left-0 top-0 z-50  ${darkMode ? "bg-slate-200" : "bg-slate-700"} bg-opacity-60 backdrop-blur-lg w-full h-full`}>
            <div className="  w-[95%] flex justify-end items-end">
              <div onClick={() => setSave(false)} className={`w-12 cursor-pointer h-12 top-[25px] justify-center flex  items-center right-[40px] relative  ${darkMode ? " bg-gray-600" : "bg-gray-400"} rounded-3xl  `}>
                <Cancel className={`text-[#F5F6F6]`} />
              </div>
            </div>
            <section className=" 100:w-[80%] h-full phone:w-[400px] flex justify-center  items-center">
              <div className={`${darkMode ? "bg-[#25282b]" : "bg-[#f5f6f6]"} 100:w-full iphone:w-96 h-fit  p-[24px]  rounded-xl shadow flex-col justify-start items-center flex`}>
                <div className="w-full flex-col justify-start items-center gap-[32px] flex">
                  <div className="w-full flex-col justify-start items-center gap-5 flex">
                    <div className={`w-12 h-12   justify-center flex  items-center ${darkMode ? "bg-emerald-600 border-emerald-500" : " bg-emerald-100 border-emerald-50"} rounded-3xl border-8   `}>
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M22 11.5799V12.4999C21.9988 14.6563 21.3005 16.7545 20.0093 18.4817C18.7182 20.2088 16.9033 21.4723 14.8354 22.0838C12.7674 22.6952 10.5573 22.6218 8.53447 21.8744C6.51168 21.1271 4.78465 19.746 3.61096 17.9369C2.43727 16.1279 1.87979 13.9879 2.02168 11.8362C2.16356 9.68443 2.99721 7.63619 4.39828 5.99694C5.79935 4.35768 7.69279 3.21525 9.79619 2.74001C11.8996 2.26477 14.1003 2.4822 16.07 3.35986M22 4.49986L12 14.5099L9.00001 11.5099"
                          stroke={` ${darkMode ? "#d1fae5" : "#039855"}`}
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="w-full flex-col justify-start text-center items-center gap-[16px] flex">
                      <h2 className={`${darkMode ? "text-[#F5F6F6]" : "text-[#495055]"} font-inter  text-[24px] font-medium leading-[25px]`}>Submitted Successfully</h2>
                      <p className={` ${darkMode ? "text-[#ccd2d5]" : "text-neutral-500"}   text-[16px] font-normal  leading-[23px]`}>Thank you for submitting your contact information. We'll get back to you as soon as possible. </p>
                    </div>
                  </div>
                  <Link className=" w-full" onClick={() => window.scrollTo(0, 0)} to="/">
                    <div
                      className={`h-[43px] w-full   px-[25px] hover:bg-[#fd992f] text-[#25282b] text-2xl font-medium font-inter py-[5px] bg-[#ffb600] rounded-3xl ${
                        darkMode ? "shadow-customWhite" : " shadow-customBlack"
                      } justify-center items-center gap-2.5 inline-flex`}
                    >
                      Close
                    </div>
                  </Link>
                </div>
              </div>
            </section>{" "}
          </div>
        </>
      )}
    </>
  );
}

export default Contact;
